<template>
  <div class="set-location">
    <div v-if="loading" class="address-search address-search--loading">
      <span>Loading...</span>
    </div>
    <div
      v-else-if="modelValue && modelValue.name"
      class="address-search address-search--current"
    >
      <div class="address">{{ modelValue.name }}</div>
      <div class="actions">
        <a class="button button--remove" @click="isOpen = !isOpen">Change</a>
      </div>
    </div>
    <transition name="quickSlide">
      <div
        class="address-search--new"
        v-show="(!modelValue || isOpen) && !loading"
      >
        <div class="address-search">
          <a
            class="button button--location"
            title="Use current location"
            v-if="
              !error &&
              !loading &&
              (!modelValue || modelValue.name !== 'Current location')
            "
            @click="getCurrentLocation()"
            >Get location</a
          >
          <Autocomplete
            v-model="selectItem"
            :getResults="getResults"
            :format="getLabel"
            :setFocus="true"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Autocomplete from "@/components/Autocomplete.vue";
import bingMaps from "@/bingMaps";

export default {
  components: {
    Autocomplete
  },
  compatConfig: { COMPONENT_V_MODEL: false },
  props: {
    getLocationOnLoad: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: this.getLocationOnLoad,
      selectItem: null,
      isOpen: this.getLocationOnLoad,
      error: null
    };
  },
  emits: ["update:modelValue"],
  methods: {
    getCurrentLocation() {
      this.loading = true;
      navigator.geolocation.getCurrentPosition(
        location => {
          this.$emit("update:modelValue", {
            name: "Current location",
            point: {
              coordinates: [location.coords.latitude, location.coords.longitude]
            }
          });
          this.loading = false;
        },
        () => {
          this.error = true;
          this.loading = false;
          this.isOpen = true;
          this.$emit("error");
        },
        {
          enableHighAccuracy: true,
          timeout: 30 * 1000
        }
      );
    },
    getLabel(item) {
      if (!item) {
        return "";
      }
      if (item.name) {
        return item.name;
      }
      if (!!item.address && !!item.address.formattedAddress) {
        return item.address.formattedAddress;
      }
      return "";
    },
    getResults(query, populateResults) {
      if (query.length < 3) {
        populateResults([]);
      }
      bingMaps
        .getAutosuggestions({
          query,
          latitude: this.$store.state.location.latitude,
          longitude: this.$store.state.location.longitude
        })
        .then(results => {
          populateResults(results);
        });
    },
    remove() {
      this.$emit("update:modelValue", null);
    }
  },
  watch: {
    async selectItem() {
      if (!this.selectItem) {
        return;
      }
      let address = await bingMaps.getLocationForAutosuggestion({
        item: this.selectItem,
        lang: this.$t.locale
      });
      this.$emit("update:modelValue", {
        ...address,
        name: this.selectItem.name || this.selectItem.address.formattedAddress
      });
    },
    modelValue() {
      if (this.isOpen && !!this.modelValue) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    if (this.getLocationOnLoad) {
      this.getCurrentLocation();
    }
  }
};
</script>
